import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "assignment-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.03 11.028a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75ZM10.78 13.278a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5ZM10.03 17.028a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75ZM8.28 10.153a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75ZM7.405 14.028a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0ZM8.28 16.154a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.998 2.246a1.75 1.75 0 0 0-1.75 1.75v.251h-1.25a2.75 2.75 0 0 0-2.751 2.751v12.005a2.75 2.75 0 0 0 2.75 2.75h12.005a2.75 2.75 0 0 0 2.751-2.75V6.998a2.75 2.75 0 0 0-2.75-2.75h-1.251v-.252a1.75 1.75 0 0 0-1.75-1.75H8.998Zm6.254 2.743v1.009a.25.25 0 0 1-.25.25H8.998a.25.25 0 0 1-.25-.25V3.996a.25.25 0 0 1 .25-.25h6.004a.25.25 0 0 1 .25.25v.993Zm1.5.758h1.25c.691 0 1.251.56 1.251 1.251v12.005c0 .69-.56 1.25-1.25 1.25H5.996c-.69 0-1.25-.56-1.25-1.25V6.998c0-.69.56-1.25 1.25-1.25h1.251v.25c0 .966.784 1.75 1.75 1.75h6.004a1.75 1.75 0 0 0 1.75-1.75v-.25Z"
    }, null, -1)
  ])))
}
export default { render: render }